import { ResourceType } from "@/enums/ResourceType";

export const skillResourceLicenses = {
  instruct: [ResourceType.microLesson, ResourceType.istationLegacyActivity],
  tutor: [
    ResourceType.tutor,
    ResourceType.skillTutor,
    ResourceType.ERSS,
    ResourceType.EPS,
    ResourceType.textSet,
  ],
  others: [ResourceType.teacherResource],
};
